import React from 'react'
import styled from "styled-components"

export const Wrapper = styled.div`
position: relative;
max-width: 420px;
font-size: 16px;
width: 90vw;
margin: 0 auto;
background: radial-gradient(ellipse at top, #5e2d8e 0%, #3a1259 60%, #2a0e42 100%);
padding: 28px 20px 20px;
border-radius: 20px;
text-align: center;
box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(94, 45, 142, 0.3);
border: 2px solid rgba(200, 160, 255, 0.2);
color: #fff;
box-sizing: border-box;

display: flex;
flex-direction: column;
gap: .2em;

img {
  max-height: 300px;
  object-fit: contain;
}

h2 {
  font-size: 1.6em;
  font-family: "Rammetto One";
  font-weight: normal;
}

.content {
  font-size: 1em;
  max-width: 280px;
  margin: 0 auto;
  margin-bottom: 20px;

  em {
    color: #fb99e1;
    text-decoration: none;
    font-style: normal;
    font-weight: bold;
  }

}

.button {

  padding: 12px 12px;
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
  font-size: 1.2rem;
  font-family: "Rammetto One", cursive;
  color: #fff;
  border-radius: 14px;
  background-color: #E839B2;
  border: 1px solid rgba(255,255,255,0.15);
  width: 100%;
  outline: none;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  box-sizing: border-box;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}


.button--learn-more {}

`

export const DetailsSubmittedModal = (props: {
  dismiss: () => void
  onLearnMore: () => void
}) => {
  const onLearnMore = () => {
    props.onLearnMore()
    props.dismiss()
  }

  return <Wrapper>
    <h2>Thank you!</h2>

    <img src="/images/gang_behind_device_glow.png" alt="Night Zookeeper" />

    <div className='content'>
      <p>Learn how Night Zookeeper makes reading & writing <em>fantastically fun</em> for children aged 6-12.</p>
    </div>

    <div className='button button--learn-more' onClick={onLearnMore}
      role='button' tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && onLearnMore()}
    >
      Learn more
    </div>
  </Wrapper>
}

